// Institution identity shown on the home page. The server may know the school from an Excel import
// (the Sekolah sheet); until it does, or when it cannot be reached, the build-time values below are
// used. Override those per deployment with VITE_SCHOOL_*; replace src/assets/logo.svg with the logo.
import { reactive } from 'vue'

const env = import.meta.env as Record<string, string | undefined>

export const institution = reactive({
  name: env.VITE_SCHOOL_NAME || 'SMA Negeri 1 Contoh',
  address: env.VITE_SCHOOL_ADDRESS || 'Jl. Pendidikan No. 1, Kota Contoh, Provinsi Contoh 12345',
  /** IANA zone the school reads its clock in; screens show exam times in it. */
  timeZone: 'Asia/Jakarta',
})

let loaded = false

/** Replace the placeholder identity with the school saved on the server. Failure is silent. */
export async function loadInstitution(): Promise<void> {
  if (loaded) return
  loaded = true
  try {
    const response = await fetch('/api/v1/school', { cache: 'no-cache' })
    if (!response.ok) return
    const school = (await response.json()) as { name?: string; academic_year?: string; semester?: string; time_zone?: string }
    if (school.time_zone) institution.timeZone = school.time_zone
    if (!school.name) return
    institution.name = school.name
    // A deployment that set its own address keeps it; otherwise the placeholder address would be
    // wrong for this school, so show the academic year instead.
    if (!env.VITE_SCHOOL_ADDRESS) {
      institution.address = school.academic_year
        ? `Tahun pelajaran ${school.academic_year}${school.semester ? ` · semester ${school.semester}` : ''}`
        : ''
    }
  } catch {
    // The build-time identity stays.
  }
}
